<template>
  <div class="title-item"><slot/></div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.title-item {
    font-weight: bold;
    font-size: 18px;
}
</style>